import { ArticleSummary } from '../article/article.types';
import { ConfigSlice } from '../config';

export const ARTICLE_LINKS_LIMIT = 8;

export enum ArticleLinksSearchQueryKey {
    Brand = 'brand',
    Category = 'category',
    Keyword = 'q',
}

export type ArticleLinksSlice = {
    links: ArticleSummary[];
    navigationId: number;
};

type SearchOptions = {
    searchLimit?: number;
};

export type SearchArticleLinksParams =
    | ({ brand: string; category?: never; keyword?: never } & SearchOptions)
    | ({ category: string; brand?: never; keyword?: never } & SearchOptions)
    | ({ keyword: string; brand?: never; category?: never } & SearchOptions);

export type FetchArticleLinksParams = SearchArticleLinksParams & {
    navigationId: number;
};

export type ArticleLinksRequestParams = SearchArticleLinksParams & {
    deployment: ConfigSlice['deployment'];
};

export const defaultArticleLinksSlice: ArticleLinksSlice = {
    links: [],
    navigationId: 0,
};
